
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'priceSummary': {'padding': `0.5rem 0rem`,},'totalPriceText': {'fontFamily': `'Lato-Regular-Bold', sans-serif`,'fontWeight': `bold`,'color': `#000000`,},'priceItem': {'display': `flex`,'justifyContent': `space-between`,'padding': `0.5rem 0rem`,'color': `#000000`,},
        
      };
    };
  